import { render, staticRenderFns } from "./BriqMultilanguagePickerPanel.vue?vue&type=template&id=cb57bf68&lang=pug&"
import script from "./BriqMultilanguagePickerPanel.vue?vue&type=script&lang=js&"
export * from "./BriqMultilanguagePickerPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports